export { default } from './GallerySlider';
